module.exports = __webpack_public_path__ + "assets/img/sohostyle_head.30c18350.svg";